import { twMerge } from 'tailwind-merge';
export const getButtonProps = (props, btnType) => {
  const {
    disabled,
    className,
    id
  } = props;
  const disabledClass = disabled ? `${btnType}Button-disabled` : '';
  const additionalClass = className || '';
  const finalClass = twMerge(`${btnType}Button`, disabledClass, additionalClass);
  const finalId = id.trim();
  const baseProps = {
    className: finalClass
  };
  if (finalId) {
    baseProps.id = finalId;
  }
  return baseProps;
};